class ProductSlider {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('[data-slider-track]');
    this.items = container.querySelectorAll('[data-slider-item]');
    this.prevBtn = container.querySelector('[data-slider-prev]');
    this.nextBtn = container.querySelector('[data-slider-next]');
    this.currentIndex = 0;
    this.itemsPerView = 3;
    this.totalItems = this.items.length;
    this.maxIndex = Math.max(0, this.totalItems - this.itemsPerView);
    this.infiniteLoop = true; // 無限ループを有効にする

    this.init();
  }

  init() {
    if (this.totalItems <= this.itemsPerView) {
      // スライダーが不要な場合はコントロールを非表示
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.style.display = 'none';
        this.nextBtn.style.display = 'none';
      }
      return;
    }

    this.bindEvents();
    this.updateButtons();
    this.updateSlider();
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prev());
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.next());
    }

    // タッチイベント対応
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    });

    this.track.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;
      
      const diffX = startX - currentX;
      const threshold = 50;

      if (Math.abs(diffX) > threshold) {
        if (diffX > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    });

    // キーボードナビゲーション
    this.container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.prev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.next();
      }
    });
  }

  prev() {
    if (this.infiniteLoop) {
      // 無限ループモード
      this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.maxIndex;
    } else {
      // 通常モード
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    }
    this.updateSlider();
    this.updateButtons();
  }

  next() {
    if (this.infiniteLoop) {
      // 無限ループモード
      this.currentIndex = this.currentIndex < this.maxIndex ? this.currentIndex + 1 : 0;
    } else {
      // 通常モード
      if (this.currentIndex < this.maxIndex) {
        this.currentIndex++;
      }
    }
    this.updateSlider();
    this.updateButtons();
  }

  updateSlider() {
    const itemWidth = 100 / this.itemsPerView;
    const translateX = -(this.currentIndex * itemWidth);
    this.track.style.transform = `translateX(${translateX}%)`;
  }

  updateButtons() {
    if (this.infiniteLoop) {
      // 無限ループモードではボタンを無効化しない
      if (this.prevBtn) {
        this.prevBtn.disabled = false;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = false;
      }
    } else {
      // 通常モード
      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentIndex === 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
      }
    }
  }

  // レスポンシブ対応
  updateItemsPerView() {
    const width = window.innerWidth;
    if (width <= 480) {
      this.itemsPerView = 1;
    } else if (width <= 768) {
      this.itemsPerView = 2;
    } else {
      this.itemsPerView = 3;
    }
    
    this.maxIndex = Math.max(0, this.totalItems - this.itemsPerView);
    
    // 無限ループモードでは調整しない
    if (!this.infiniteLoop) {
      // 現在のインデックスが最大値を超えないように調整
      if (this.currentIndex > this.maxIndex) {
        this.currentIndex = this.maxIndex;
      }
    }
    
    this.updateSlider();
    this.updateButtons();
  }
}

// ページ読み込み時にスライダーを初期化
document.addEventListener('DOMContentLoaded', () => {
  const rankingContainer = document.querySelector('.home-ranking__container');
  const productsContainer = document.querySelector('.home-products__container');
  
  if (rankingContainer) {
    new ProductSlider(rankingContainer);
  }
  
  if (productsContainer) {
    new ProductSlider(productsContainer);
  }

  // リサイズ時の対応
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const sliders = document.querySelectorAll('.home-ranking__container, .home-products__container');
      sliders.forEach(container => {
        const slider = container._slider;
        if (slider) {
          slider.updateItemsPerView();
        }
      });
    }, 250);
  });
});
